import { Body1Strong, Title3 } from "@fluentui/react-components";
import { H1_TEXT, useStyles } from "./urlNotFoundPage.styles";

const SORRY_NOT_FOUND_MESSAGE =
  "Sorry, we could not find the page you were looking for";
const CODE_TEXT = "404";
const PAGE_NOT_FOUND_TEXT = "Page Not Found";

export const UrlNotFoundPage = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.wrapper}>
      <div className={styles.code}>{CODE_TEXT}</div>
      <Title3 as={H1_TEXT}>{PAGE_NOT_FOUND_TEXT}</Title3>
      <Body1Strong>{SORRY_NOT_FOUND_MESSAGE}</Body1Strong>
    </div>
  );
};
